import React, { Component } from 'react'
import {Link} from 'react-router-dom';
import { addMovieBack,handleMovieDetails, handleMoreMovies } from '../actions'

export default class HomePoster extends Component {
    render() {
        const { data } =this.props;
        const detailsHandle = ()=>{
            const {dispatch} =this.props;
            dispatch(addMovieBack(data.backdrop_path));
            dispatch(handleMovieDetails(data.title));
            dispatch(handleMoreMovies(data.original_language,data.genre_ids[0]));
            window.scrollTo({
                top: 0,
                behavior: "smooth"
              });
         }
 
        return (
            <Link style={{textDecoration:'none'}} to="/movie-details">
            <div onClick={detailsHandle} className="poster-container">
            <p className="container-title">Today's Trending</p>
              <div className="poster" style={{backgroundImage:`url('https://image.tmdb.org/t/p/original/${data.backdrop_path}')`}}>
                <div className="poster-detail" >
                <div className="p-detail">
                    <p className="movie-title" >{data.title}</p> 
                  
                    <span className="detail"><span>{data.release_date.substr(0,4)}</span>{data.adult&&<span>18+</span>}{!data.adult&&<span className="line">18+</span>}<span>{data.original_language}</span><span className="last">Action</span></span>  
                    <p className="movie-detail">After a sudden global event wipes out all electronics and takes away humankind’s ability to sleep, chaos quickly begins to consume the world. Only Jill, an ex-soldier with a troubled past, may hold the key to a cure in the form of her own daughter. The question is, can Jill safely deliver her daughter and save the world before she herself loses her mind."</p>
                </div>
                </div>
             </div>
            </div>
            </Link>
        )
    }
}
